import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpsgenieComponent } from './simple-icons-opsgenie.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpsgenieComponent ],
    exports:      [ SimpleIconsOpsgenieComponent ],
    bootstrap:    []
})
export class SimpleIconsOpsgenieModule {}
